








































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { IRussiaResortRegion, RussiaResortCity } from '../plugins/store.russiaResort';
import { latLng, LatLng, divIcon, latLngBounds, Map } from 'leaflet';
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LControl } from 'vue2-leaflet';

@Component({
	components: {
		LMap,
		LTileLayer,
		LMarker,
		LPopup,
		LTooltip,
		LControl,
	},
})
export default class RussiaResortRegionMap extends Vue {
	@Prop({ required: true, type: Number }) public regionCode: number;
	public zoom: number = 13;
	public url: string = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
	public attribution: string = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
	public mapOptions = {
		closePopupOnClick: false,
	};
	public popupOptions = {
		autoClose: false,
	};
	public get currentUUID() {
		return this.regionCode.toString().padStart(2, '0');
	}

	public get region(): IRussiaResortRegion {
		return this.$store.getters['russiaResort/getRegionByCode'](this.regionCode);
	}

	public created() {
		this.resetZoom();
	}

	private close() {
		this.$router.back();
	}

	private getTouristIcon(city: RussiaResortCity) {
		const html = `<i class="fas fa-map-marker-alt fa-3x" style="color:#0d8bf2;"></i>`;
		return divIcon({ html, iconSize: [37, 37], className: 'map-icon-style' });
	}
	private getLatLng(coord: string): L.LatLng {
		const [lat, lng] = coord.split(' ').map((v) => parseFloat(v.replace(/,/g, '.')));
		if (Number.isNaN(lat)) {
			return latLng(0, 0);
		}
		return latLng(lat, lng);
	}

	private resetZoom() {
		this.$nextTick(() => {
			if (this.region.code > 1) {
				const l = (this.$refs.lmap as any).mapObject as Map;
				const cityCoordinates = this.region.russiaResortCities.map((v) => v.coordinate);
				const bounds = latLngBounds(cityCoordinates.map((v) => this.getLatLng(v)));
				l.fitBounds(bounds);
			}
		});
	}

	@Watch('region', { deep: true })
	private onRegionChange() {
		this.resetZoom();
	}
}
